import {Component, Input} from '@angular/core';
import {Service} from '../../../entities/photographer/service.entity';
import {PhotographerService} from '../photographer-service/photographer-service';
import {TranslocoPipe} from '@jsverse/transloco';
import {RouterLink} from '@angular/router';
import {EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-photographer-services',
  templateUrl: './photographer-services.html',
  imports: [
    PhotographerService,
    TranslocoPipe,
    RouterLink
  ],
  standalone: true,
  styleUrl: './photographer-services.scss'
})
export class PhotographerServices {
  @Input() services: Service[]|null = null;
  @Input() photographerFirstName: string|null = null;
  @Output() serviceClick = new EventEmitter<Service>();
}
